import {Button, Drawer, Dropdown, Space} from "antd";
import {DownOutlined} from "@ant-design/icons";

const MobileDrawer = ({
                          openMenu,
                          setOpenMenu,
                          handleHomeNavigation,
                          isHomeRoute,
                          scrollToSection,
                          aboutRef,
                          servicesRef,
                          projectsMenuItems,
                          showDrawer
                      }) => {
    return (<Drawer
            placement="right"
            onClose={() => setOpenMenu(false)}
            open={openMenu}
            rootClassName="custom-drawer"
            closable={false}
            width="200px"
        >
            <div className="flex flex-col gap-6">
                <Button type="text" className="custom-navbar-item" onClick={handleHomeNavigation}>
                    Home
                </Button>

                {isHomeRoute && (<>
                        <Button type="text" className="custom-navbar-item" onClick={() => scrollToSection(aboutRef)}>
                            About
                        </Button>
                        <Button type="text" className="custom-navbar-item" onClick={() => scrollToSection(servicesRef)}>
                            Services
                        </Button>
                    </>)}
                <Dropdown rootClassName="mobile-view-custom-dropdown-menu" menu={{items: projectsMenuItems}}
                          placement="bottomCenter">
                    <Button type="text" className="custom-navbar-item flex items-center justify-center">
                        <Space>
                            Projects
                            <DownOutlined/>
                        </Space>
                    </Button>
                </Dropdown>
                <Button type="text" className="custom-navbar-item" onClick={showDrawer}>
                    Contact Us
                </Button>
            </div>
        </Drawer>);
};

export default MobileDrawer;
